const fxConversion = {
  35: {
    rank: 99,
    score: 140,
    class: 'very superior',
  },
  34: {
    rank: 99,
    score: 138,
    class: 'very superior',
  },
  33: {
    rank: 99,
    score: 135,
    class: 'very superior',
  },
  32: {
    rank: 98,
    score: 132,
    class: 'very superior',
  },
  31: {
    rank: 97,
    score: 129,
    class: 'superior',
  },
  30: {
    rank: 96,
    score: 127,
    class: 'superior',
  },
  29: {
    rank: 95,
    score: 124,
    class: 'superior',
  },
  28: {
    rank: 92,
    score: 121,
    class: 'superior',
  },
  27: {
    rank: 88,
    score: 118,
    class: 'high average',
  },
  26: {
    rank: 86,
    score: 116,
    class: 'high average',
  },
  25: {
    rank: 81,
    score: 113,
    class: 'high average',
  },
  24: {
    rank: 75,
    score: 110,
    class: 'high average',
  },
  23: {
    rank: 70,
    score: 108,
    class: 'average',
  },
  22: {
    rank: 63,
    score: 105,
    class: 'average',
  },
  21: {
    rank: 55,
    score: 102,
    class: 'average',
  },
  20: {
    rank: 50,
    score: 100,
    class: 'average',
  },
  19: {
    rank: 42,
    score: 97,
    class: 'average',
  },
  18: {
    rank: 34,
    score: 94,
    class: 'average',
  },
  17: {
    rank: 27,
    score: 91,
    class: 'average',
  },
  16: {
    rank: 21,
    score: 88,
    class: 'low average',
  },
  15: {
    rank: 18,
    score: 86,
    class: 'low average',
  },
  14: {
    rank: 13,
    score: 83,
    class: 'low average',
  },
  13: {
    rank: 9,
    score: 80,
    class: 'low average',
  },
  12: {
    rank: 7,
    score: 78,
    class: 'below average',
  },
  11: {
    rank: 5,
    score: 75,
    class: 'below average',
  },
  10: {
    rank: 3,
    score: 72,
    class: 'below average',
  },
  9: {
    rank: 2,
    score: 69,
    class: 'well below average',
  },
  8: {
    rank: 1,
    score: 67,
    class: 'well below average',
  },
  7: {
    rank: 1,
    score: 64,
    class: 'well below average',
  },
  6: {
    rank: 1,
    score: 61,
    class: 'well below average',
  },
  5: {
    rank: 1,
    score: 59,
    class: 'well below average',
  },
  4: {
    rank: 1,
    score: 56,
    class: 'well below average',
  },
  3: {
    rank: 1,
    score: 53,
    class: 'well below average',
  },
  2: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  1: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
  0: {
    rank: 1,
    score: 50,
    class: 'well below average',
  },
};

export default fxConversion;
